<script setup>
import { ref } from 'vue'
import { useGlobalStore } from '@stores/global'
import { register } from 'swiper/element/bundle'
import { Autoplay } from 'swiper/modules'
import Input from '@components/global/input.vue'
import Textarea from '@components/global/textarea.vue'
import Button from '@components/global/button.vue'
import 'swiper/css'

register()

const global = useGlobalStore()
const processing = ref(false)
const success = ref(false)
const inquiry = ref({})
const errors = ref({})

const breakpoints = ref({
	0: {
		slidesPerView: 3,
	},
	375: {
		slidesPerView: 3,
	},
	512: {
		slidesPerView: 4,
	},
	640: {
		slidesPerView: 5,
	},
	768: {
		slidesPerView: 6,
	},
	1024: {
		slidesPerView: 6,
	},
})

function submit(form) {
	form.preventDefault()
	if (!processing.value) {
		processing.value = true
		axios
			.post('/api/wholesale', inquiry.value)
			.then(() => {
				errors.value = {}
				processing.value = false
				success.value = true
			})
			.catch((error) => {
				console.error(error)
				processing.value = false
				success.value = false
				if (error.response.status === 422) errors.value = error.response.data.errors
			})
	}
}
</script>

<template>
	<section class="container flex flex-col items-center gap-6 text-center">
		<span class="h9">Reach out</span>
		<h1>Wholesale</h1>
		<p class="lg:w-3/4">Interested in becoming a Garden Mother wholesale partner? Fill out the form below and we'll get back to you as soon as possible.</p>
	</section>
	<section v-if="global.wholesalePartners.length > 0">
		<div class="container flex justify-center">
			<div class="w-full lg:w-3/4">
				<swiper-container
					allow-touch-move="false"
					:modules="[Autoplay]"
					:breakpoints="breakpoints"
					:space-between="24"
					:loop="true"
					:autoplay="{
						delay: 1000,
						pauseOnMouseEnter: false,
					}">
					<template v-for="i in 20">
						<swiper-slide class="flex justify-center" v-for="wholesalePartner of global.wholesalePartners">
							<img class="h-20 grayscale" :src="wholesalePartner.logo" alt="" />
						</swiper-slide>
					</template>
				</swiper-container>
			</div>
		</div>
	</section>
	<section>
		<div class="container">
			<div class="flex justify-center">
				<div class="grid w-full grid-cols-1 gap-4 rounded-2xl bg-bgSecondary p-8 font-medium lg:p-14" v-if="success">Thank you, we will get back to you as soon as possible.</div>
				<form class="grid w-full grid-cols-1 gap-4 rounded-2xl bg-bgSecondary p-8 md:grid-cols-2 lg:w-3/4 lg:p-14" @submit="submit" v-else>
					<Input placeholder="Insert your first name here" label="First name" class="col-span-2 md:col-span-1" autocomplete="given-name" :required="true" v-model="inquiry.first_name" :error="errors.first_name && errors.first_name[0]" />
					<Input placeholder="Insert your last name here" label="Last name" class="col-span-2 md:col-span-1" autocomplete="family-name" :required="true" v-model="inquiry.last_name" :error="errors.last_name && errors.last_name[0]" />
					<Input placeholder="Insert your email here" label="Email" class="col-span-2" autocomplete="email" :required="true" v-model="inquiry.email" :error="errors.email && errors.email[0]" />
					<Input placeholder="Insert your phone here" label="Phone" class="col-span-2 md:col-span-1" autocomplete="tel" v-model="inquiry.phone" :error="errors.phone && errors.phone[0]" />
					<Input placeholder="Insert your company name here" label="Company" class="col-span-2 md:col-span-1" autocomplete="organization" :required="true" v-model="inquiry.company" :error="errors.company && errors.company[0]" />
					<Textarea placeholder="Insert your message here" label="Message" class="col-span-2" rows="10" v-model="inquiry.details" :error="errors.details && errors.details[0]" />
					<Button label="Send" class="primary col-span-2" type="submit" />
				</form>
			</div>
		</div>
	</section>
</template>
